import { render, staticRenderFns } from "./add-letter.vue?vue&type=template&id=a60e7b0c&scoped=true"
import script from "./add-letter.vue?vue&type=script&lang=js"
export * from "./add-letter.vue?vue&type=script&lang=js"
import style0 from "./add-letter.vue?vue&type=style&index=0&id=a60e7b0c&prod&lang=css"
import style1 from "./add-letter.vue?vue&type=style&index=1&id=a60e7b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60e7b0c",
  null
  
)

export default component.exports